import { render, staticRenderFns } from "./LeagueMappingModal.vue?vue&type=template&id=0b890d9f&scoped=true&"
import script from "./LeagueMappingModal.vue?vue&type=script&lang=js&"
export * from "./LeagueMappingModal.vue?vue&type=script&lang=js&"
import style0 from "./LeagueMappingModal.vue?vue&type=style&index=0&id=0b890d9f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b890d9f",
  null
  
)

export default component.exports